import httpClient from '@/services/http/httpClient'

export const apiPostTimeStamp = (timeStamp) => {
  return httpClient.post('api-token-auth/auditTMO/', timeStamp)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
